export const OPEN_SIGN_IN = 'OPEN_SIGN_IN';
export const OPEN_SIGN_UP = 'OPEN_SIGN_UP';
export const OPEN_FORGOT_PASSWORD = 'OPEN_FORGOT_PASSWORD';
export const OPEN_SELECT_ROLE = 'OPEN_SELECT_ROLE';
export const CLOSE_ALL = 'CLOSE_ALL';
export const OPEN_HAS_CONFIRM_ROTATION = 'OPEN_HAS_CONFIRM_ROTATION';
export const OPEN_WHITELIST = 'OPEN_WHITELIST';
